import {AbilityBuilder} from "@casl/ability";
import {AppAbilityType} from "../authorisation";

/**
 * The base class for ruleset.
 *
 * @abstract
 */
abstract class RulesetBase {
  /**
   * The AbilityBuilder used to define the rules.
   */
  protected readonly abilityBuilder: AbilityBuilder<AppAbilityType>;

  constructor(abilityBuilder: AbilityBuilder<AppAbilityType>) {
    this.abilityBuilder = abilityBuilder;
  }

  /**
   * Add rules to the AbilityBuidler.
   */
  abstract defineRules: (
    userPermissions: string[],
    userRoles?: string[] | null
  ) => void;
}

export default RulesetBase;
